// Error message when the agent didn't change the skills.
export const UNCHANGED_ERROR = "Unchanged";
